
import Carousel from 'react-multi-carousel';
import utn from '../assets/img/utn.png';
import codo from '../assets/img/codo.png';
import nc from '../assets/img/nc.png';
import udemy from '../assets/img/udemy.png';
import educacionit from '../assets/img/educacionit.png';
import { useTranslation } from 'react-i18next';
export const Newsletter = () => {
  const [t] = useTranslation("global");

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  return (
    <section className="mb-3 padding-remove " id="certificados" >
        <div className="container">
            <div className="row">
                <div className="col-12 padding-remove">
                    <div style={{Zindex:'2',backgroundColor:'#F7F4FF',color:'black',marginBottom:'50px',borderRadius:'0px'}} className="skill-bx wow zoomIn box block">
                       <h2>{t("certifications")}</h2>
                        {/*<p><br></br>  Tengo amplios conocimientos y experiencia en las siguientes tecnologias: </p>*/}
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={udemy} alt="udemy" />
                                <h5>Udemy</h5>
                            </div>
                            <div className="item">
                                <img src={educacionit} alt="educacionit" />
                                <h5>Educacion IT</h5>
                            </div>
                            <div className="item">
                                <img src={utn} alt="utn" />
                                <h5>UTN</h5>
                            </div>
                            <div className="item">
                                <img src={codo} alt="codoacodo" />
                                <h5>Codo a codo</h5>
                            </div>
                            <div className="item">
                                <img src={nc} alt="nocountry" />
                                <h5>No Country</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
